import './toolCards.css';
import React, { useState } from 'react';

import IconsBackground from '../../assets/icons/iconsBackground/iconsBackground';
import Button from '../button/button';
import SpaceBar from '../spacerBars/spaceBar';


export default function ToolCards({size, icon, title, barBool, barCenter, barWidth, barOffset, barThick, barColor, subTitle, subTitleTwo, textContentTop, bulletPoints, textContentBottom, buttonBool, button, onClick}) {

    // a bool that will set the card size
    //const cardSize = size ? '36rem' : '42rem';
    const [cardSize, setCardSize] = useState(size);

    // bool for the card bar
    const [activeBar, setActiveBar] = useState(barBool);

    // bool for button 
    const [activeButton, setActiveButton] = useState(buttonBool);

    // bool for no Icon
    const [activeIcon, setActiveIcon] = useState(icon);
    
    

    return(
        <div>
            <div className="tool-cards" style={{ transform: `${activeIcon ? 'translateY(-8rem)' : 'translateY(0rem)'}` }}>
                {activeIcon &&<div className="tool-cards-icon-container" style={{ width: `${cardSize ? '36rem' : '42rem'}` }}>
                     <div className="tool-cards-icon">{icon}<IconsBackground/></div>
                </div>}
                <div className="tool-cards-body" style={{ width: `${cardSize ? '36rem' : '42rem'}` }}>
                    <h2 className={`${cardSize ? '' : 'tool-cards-body-title-large'}`}>{title}</h2>
                    <h4 className="in-action-card-title">{subTitleTwo}</h4>
                    {barBool && <SpaceBar width={barWidth} center={barCenter} thick={barThick} color={barColor} offset={barOffset}/>}
                    <h4 className={`${cardSize ? '' : 'tool-cards-body-sub-title-large'}`}>{subTitle}</h4>
                    <p className="tool-card-top-text">{textContentTop}</p>
                    {bulletPoints?.map((text, index) => (
                        <div className="tool-card-bullet-points" style={{ width: `${cardSize ? '36rem' : '42rem'}`, borderRadius: `${cardSize ? '2rem' : '10rem'}`}}>
                            <div className="expensible-bullet-point"></div>
                            <p key={index}>{text}</p>
                        </div>
                    ))}
                    <p className="textContentBottom">{textContentBottom}</p> 
                    
                    <div className="tool-cards-button" onClick={onClick}>{buttonBool && <Button buttonName={button} />}</div>

                </div>
            </div>
        </div>
    )
}